<template>
  <div class="graph-container as-flex main-start cross-center">
    <div class="left-side">
      <div class="title-type as-flex main-between cross-center">
        <div class="title-type-title f-3 as-flex main-start cross-center">
          <p>{{tagsMapping[indexId]}}</p>
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div class="tip-content" slot="content">{{indicatorIntroduction[indexId]}}</div>
            <i class="icon-2 page-icon showDetailIcon" @click="showTagIntroduction(indexId)"></i>
          </el-tooltip>
          <!-- <i class="icon-2 page-icon showDetailIcon" @click="showTagIntroduction(indexId)"></i> -->
          <p
            v-if="cycle.id !== 'overall'"
            class="cycle-name f-2"
          >{{privateOffset?privateOffset.name:cycle.name}}</p>
        </div>
        <div class="as-flex main-end cross-center f-2">
          <!-- 预期达成单选框 -->
          <div
            v-if="indexId === 'expectation'"
            class="chart-toggle expectation as-flex main-center cross-center"
          >
            <div
              @click="changeToggle(0)"
              :class="['toggle-item','as-flex','main-center','cross-center','toggle-left' ,toggleValue===0?'is-active':'']"
            >超过预期</div>
            <div
              @click="changeToggle(1)"
              :class="['toggle-item','as-flex','main-center','cross-center','toggle-right',toggleValue===1?'is-active':'']"
            >未达预期</div>
          </div>
          <!-- 首选分流单选框 -->
          <div
            v-if="indexId === 'primary_div'"
            class="chart-toggle primary-div as-flex main-center cross-center"
          >
            <div
              @click="changeToggle(0)"
              :class="['toggle-item','as-flex','main-center','cross-center','toggle-left' ,toggleValue===0?'is-active':'']"
            >谁分了我</div>
            <div
              @click="changeToggle(1)"
              :class="['toggle-item','as-flex','main-center','cross-center','toggle-right',toggleValue===1?'is-active':'']"
            >我分了谁</div>
          </div>
          <!-- 表格/图表切换图表 -->
          <!-- <i
            :class="['page-icon' ,'el-icon-more', isChart?'type-table':'type-chart']"
            @click="toggleGraph"
          ></i>-->
          <el-dropdown v-if="indexId != 'indicator'">
            <span class="el-dropdown-link">
              <i :class="['page-icon' ,'el-icon-more', isChart?'type-table':'type-chart']"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div @click="toggleGraph">切换{{isChart?'表格':'图表'}}</div>
              </el-dropdown-item>
              <el-dropdown-item v-if="userInfo.can_download">
                <div @click="copyTableExcel">复制EXCEL</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div
        class="has-no-data as-flex flex-vertical main-center cross-center"
        v-if="hasNoData && !['primary_div'].includes(indexId)"
      >
        <img class="has-no-data-img" src="../../assets/images/has-no-data-3x.png" alt />
        <div class="has-no-data-tip fc-gray-2 f-2">暂无监测数据</div>
      </div>

      <div
        class="has-no-data as-flex flex-vertical main-center cross-center"
        v-if="hasNoData && !['indicator'].includes(indexId)"
      >
        <img class="has-no-data-img" src="../../assets/images/has-no-data-3x.png" alt />
        <div class="has-no-data-tip fc-gray-2 f-2"></div>
      </div>
      <div v-else class="graph" v-loading.lock="isLoading">
        <template v-if="isChart">
          <div class="as-full-width as-full-height" v-if="indexId === 'primary_div'">
            <primary_div_chart
              :key="indexId"
              @setOffset="setPrivateOffset"
              :config="primary_div_config"
              @loadingStatus="(status)=>{changeLoadingStatus(status)}"
              @updateData="updateGraphData"
            ></primary_div_chart>
          </div>
          <div class="as-full-width as-full-height" v-else-if="indexId === 'indicator'">
            <indicator_chart
              :key="indexId"
              @setOffset="setPrivateOffset"
              @loadingStatus="(status)=>{changeLoadingStatus(status)}"
              :config="indicator_config"
              @updateData="updateGraphData"
            ></indicator_chart>
          </div>
          <div class="as-full-width as-full-height" v-else>
            <graph_chart
              class="as-full-width as-full-height"
              :key="indexId"
              :graph_config="graphConfig"
              @loadingStatus="(status)=>{changeLoadingStatus(status)}"
            ></graph_chart>
          </div>
        </template>
        <template v-if="!isChart">
          <div class="as-full-width as-full-height" v-if="indexId === 'primary_div'">
            <primary_div_table
              :key="indexId"
              :config="primary_div_config"
              @loadingStatus="(status)=>{changeLoadingStatus(status)}"
              @updateData="updateGraphData"
            ></primary_div_table>
          </div>
          <div class="as-full-width as-full-height" v-else-if="indexId === 'indicator'">
            <indicator_table
              :key="indexId"
              :config="indicator_config"
              @loadingStatus="(status)=>{changeLoadingStatus(status)}"
              @updateData="updateGraphData"
            ></indicator_table>
          </div>
          <div class="as-full-width as-full-height" v-else>
            <graph_table
              class="as-full-width as-full-height"
              :key="indexId"
              :graph_config="graphConfig"
              @loadingStatus="(status)=>{changeLoadingStatus(status)}"
            ></graph_table>
          </div>
        </template>
      </div>
    </div>

    <div class="right-side as-flex flex-vertical main-end cross-center">
      <div class="tag-level2 f-1 as-flex main-center cross-center">
        <template v-for="(item,index) in subCrowd">
          <div
            v-if="item.id"
            :key="item.id"
            @click="toggleCrowd(item.id)"
            :class="['subCrowdBox','as-flex ','main-center', 'cross-center', 'f-1']"
            :style="returnCurrentTagStyle(item.id,index) "
          >{{item.name}}</div>
        </template>
      </div>
      <div class="movie-list as-flex main-start cross-center">
        <template v-if="mainMovie[0]&&mainMovie[0].id">
          <div
            :key="mainMovie[0].id"
            class="movieBox as-flex main-center cross-center"
            @click="toggleActiveMovie(mainMovie[0].id)"
          >
            <i class="movie-circle" :style="returnCurrentMovieStyle(mainMovie[0].id,0)"></i>
            <span class="movie-title f-1">{{mainMovie[0].title}}</span>
            <i class="movie-circle hidden-movie-circle"></i>
          </div>
        </template>
        <template v-if="includeTotalAverage">
          <template v-for="(item) in movieList.slice(0,1)">
            <div
              v-if="!['primary_div','indicator'].includes(indexId)"
              :key="item.id"
              class="movieBox as-flex main-start cross-center"
              @click="toggleActiveMovie(item.id)"
            >
              <i class="movie-circle" :style="returnCurrentMovieStyle(item.id,-1)"></i>
              <span class="movie-title f-1">{{item.title}}</span>
              <i class="movie-circle hidden-movie-circle"></i>
            </div>
          </template>
          <template v-for="(item,index) in movieList.slice(1)">
            <div
              v-if="item.id !== 0 || !['primary_div','indicator'].includes(indexId)"
              :key="item.id"
              class="movieBox as-flex main-start cross-center"
              @click="toggleActiveMovie(item.id)"
            >
              <i
                class="movie-circle"
                :style="returnCurrentMovieStyle(item.id,mainMovie[0]&&mainMovie[0].id?index+1:index)"
              ></i>
              <span class="movie-title f-1">{{item.title}}</span>
              <i class="movie-circle hidden-movie-circle"></i>
            </div>
          </template>
        </template>
        <template v-else>
          <template v-for="(item,index) in movieList">
            <div
              v-if="item.id !== 0 || !['primary_div','indicator'].includes(indexId)"
              :key="item.id"
              class="movieBox as-flex main-start cross-center"
              @click="toggleActiveMovie(item.id)"
            >
              <i
                class="movie-circle"
                :style="returnCurrentMovieStyle(item.id,mainMovie[0]&&mainMovie[0].id?index+1:index)"
              ></i>
              <span class="movie-title f-1">{{item.title}}</span>
              <i class="movie-circle hidden-movie-circle"></i>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const tagsMapping = {
  awareness: "认知度",
  interest: "兴趣度",
  primary: "首选度",
  secondary: "次选",
  rating: "喜爱度",
  recommendation: "推荐度",
  expectation: "预期达成",
  primary_div: "首选分流",
  indicator: "类型感知"
};
const crowdMapping = {
  overall: "总体",
  male: "男",
  female: "女",
  below25: "<25",
  above25: "≥25",
  male_below25: "<25男",
  male_above25: "≥25男",
  female_below25: "<25女",
  female_above25: "≥25女",
  tier1: "一线城市",
  tier2: "二线城市",
  tier3: "三线城市",
  below30: "<30",
  above30: "≥30",
  male_below30: "<30男",
  male_above30: "≥30男",
  female_below30: "<30女",
  female_above30: "≥30女",
  layer1: "18-24",
  layer2: "25-29",
  layer3: "30-34",
  layer4: "≥35",
  student: "学生",
  non_student: "非学生",
  parent: "家长",
  non_parent: "非家长"
};
const indicatorIntroduction = {
  awareness: "在调研周期节点，'听说过'此影片的样本中对此影片类型感知的比例",
  interest:
    "在调研周期节点，'听说过且没看过'此影片的样本中对此影片'非常感兴趣'的比例。",
  primary:
    "在调研周期节点，对此影片'非常感兴趣和比较感兴趣'的样本中'下次观影首先选择'此影片的比例。",
  rating:
    "在调研周期节点，'看过'此影片的样本中对此影片整体评价'非常棒'的比例。",
  secondary:
    "在调研周期节点，对此影片'非常感兴趣和比较感兴趣'的样本中'下次观影第二选择'此影片的比例",
  recommendation:
    "在调研周期节点，'看过'此影片的样本中'肯定会'将此影片推荐给他人的比例。",
  expectation:
    "超出预期:在调研周期节点，'看过'此影片的样本中认为此影片'超出预期'的比例。未达预期:在调研周期节点，'看过'此影片的样本中认为此影片'未达预期'的比例。",
  primary_div:
    "谁分了我的:在调研周期节点，对此影片'非常感兴趣和比较感兴趣'的样本，在选择'下次观影首先选择'影片时，除了选择此影片外，还选择了其他影片的比例。\n我分了谁的:在调研周期节点，选择了此影片作为'下次观影首先选择'影片的样本，对其他影片'非常感兴趣和比较感兴趣'的比例。",
  indicator: "在调研周期节点，'听说过'此影片的样本中对此影片类型感知的比例。"
};
import graph_chart from "./chart.vue";
import primary_div_chart from "./primarydivChart.vue";
import indicator_chart from "./typeawarenessChart.vue";
import graph_table from "./table.vue";
import primary_div_table from "./primarydivTable.vue";
import indicator_table from "./indicatorTable.vue";
import { clone, cloneDeep, isEqual } from "lodash";
import dataProcessMixin from "../../mixin/movie_data_process_of_graphContainer.js";
import surveyApi from "../../api/surveyApi.js";
import movieApi from "../../api/movieApi.js";
import colorManage from "../../utils/colorManage";
import Vue from "vue";
import { mapGetters } from "vuex";
//copy-func
import tableDataCopy from "../../utils/tableDataCopyFunc";
export default {
  name: "graphContainer",
  mixins: [dataProcessMixin],
  props: {
    mainMovie: { default: [] },
    movieList: { default: [] },
    indexId: { default: undefined },
    crowd: { id: "", name: "" },
    cycle: { default: null },
    beforeAfter: { default: "before" }
  },
  components: {
    graph_chart: graph_chart,
    primary_div_chart: primary_div_chart,    
    indicator_chart: indicator_chart,
    graph_table: graph_table,
    primary_div_table: primary_div_table,
    indicator_table: indicator_table
  },
  data() {
    return {
      indicatorIntroduction: indicatorIntroduction,
      surveyApi: new surveyApi(),
      movieApi: new movieApi(),
      //配置类数据
      colorArray: clone(colorManage.movieColorArray),
      tagColorMapping: clone(colorManage.tagColorMapping),
      tagsMapping: tagsMapping,
      includeTotalAverage: true,
      //容器筛选条件选择
      currentSubCrowd: {},
      currentActiveMovie: {},
      //若表格内部改变了本表格的周期，显示此周期
      privateOffset: undefined,
      subCrowd: {},
      //切换按钮 0为left 1为right
      toggleValue: 0,
      //表格和图表切换
      isChart: true,
      hasNoData: false,
      downloadUrl: undefined
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "user/getUserInfo"
    }),
    crowdSingleMulti: function() {
      if (this.indexId === "primary_div" || this.indexId === "indicator") {
        return "single";
      }
      return Object.entries(this.currentActiveMovie).filter(item => {
        return item[1] === true;
      }).length > 1
        ? "single"
        : "multi";
    },
    movieSingleMulti: function() {
      if (this.indexId === "primary_div" || this.indexId === "indicator") {
        return "single";
      }
      return Object.entries(this.currentSubCrowd).filter(item => {
        return item[1] === true;
      }).length > 1
        ? "single"
        : "multi";
    },
    primary_div_config: function() {
      return {
        movie_id: Object.entries(this.currentActiveMovie).filter(item => {
          return item[0] !== "0";
        })[0],
        crowd: this.currentSubCrowd,
        offset: this.cycle,
        is_div_me: this.toggleValue === 0 ? true : false
      };
    },
    indicator_config: function() {
      return {
        movie_id: this.currentActiveMovie,
        crowd: this.currentSubCrowd,
        offset: this.cycle,
        indicator: undefined
      };
    }
  },
  methods: {
    updateGraphData(data) {
      if (!["primary_div", "indicator"].includes(this.indexId)) {
        return;
      }
      this.graphConfig = clone(data);
    },
    async copyTableExcel() {
      let type = undefined;
      if (["primary_div", "indicator"].includes(this.indexId)) {
        type = this.indexId;
        this.graphConfig = Object.assign({}, this.graphConfig, {
          crowd: crowdMapping[Object.keys(this.currentSubCrowd)[0]]
        });
      } else {
        type = "normal";
      }
      let copyResult = await tableDataCopy.call(this, {
        data: clone(this.graphConfig),
        type: type,
        base: true
      });
      if (copyResult) {
        //cp success
        this.$notify({
          title: "成功",
          message: "复制成功",
          type: "success"
        });
      } else {
        //cp failed
        this.$notify({
          title: "失败",
          message: "复制失败",
          type: "error"
        });
      }
    },
    //新指标需返回最新周期
    setPrivateOffset(offset) {
      this.privateOffset = clone(this.cycle);
      this.privateOffset.name = offset.name;
    },
    showTagIntroduction(tag_id) {
      //return tag introduction
      this.$emit("showTagIntroduction", tag_id);
    },
    changeToggle(value) {
      this.toggleValue = value;
    },
    toggleGraph() {
      this.isChart = !this.isChart;
    },
    // async downloadExcel() {
    //   let ids = Object.entries(this.currentActiveMovie)
    //     .filter(item => {
    //       return item[1] === true;
    //     })
    //     .map(item => {
    //       return item[0];
    //     });
    //   let crowd = Object.entries(this.currentSubCrowd)
    //     .filter(item => {
    //       return item[1] === true;
    //     })
    //     .map(item => {
    //       return item[0];
    //     });
    //   let offset = this.cycle.id;
    //   let indicator = this.indexId;
    //   let is_div_me = this.primary_div_config.is_div_me;
    //   // console.log(this.cycle);
    //   let res = await this.movieApi.exportChartData({
    //     ids,
    //     crowd,
    //     offset,
    //     indicator,
    //     is_div_me
    //   });
    //   if (res.code === 200 && res.status === true) {
    //     window.open(res.data.url, "_blank");
    //   } else {
    //     this.$message.error("下载表格出错");
    //   }
    // },
    toggleCrowd(id) {
      //两个条件： 是否可以多选 & 当前标签状态
      if (this.crowdSingleMulti === "single") {
        let temp = {};
        temp[id] = true;
        this.currentSubCrowd = clone(temp);
      } else {
        let temp = clone(this.currentSubCrowd);
        temp[id] = !temp[id];
        this.currentSubCrowd = temp;
      }
    },
    toggleActiveMovie(id) {
      //两个条件： 是否可以多选 & 当前标签状态
      if (this.movieSingleMulti === "single") {
        this.currentActiveMovie = {};
        let temp = {};
        temp[id] = true;
        this.currentActiveMovie = clone(temp);
      } else {
        let temp = Object.assign({}, this.currentActiveMovie);
        temp[id] = !temp[id];
        this.currentActiveMovie = Object.assign({}, temp);
      }
    },
    returnCurrentTagStyle(id, index) {
      //根据tag状态为tag分配颜色
      if (this.currentSubCrowd[id]) {
        //被选中
        if (this.crowdSingleMulti === "single") {
          //单选
          return {
            background: "#4A4A4A!important",
            color: "#ffffff"
          };
        } else {
          //多选
          //确定人群标签对应的颜色
          this.colorMapping.tag[id] = this.tagColorMapping[id];
          return {
            background: this.tagColorMapping[id] + "!important",
            color: "#ffffff"
          };
        }
      } else {
        //未被选中
        return {
          border: "1px solid #666666",
          background: "#ffffff!important",
          color: "#666666"
        };
      }
    },
    returnCurrentMovieStyle(id, index) {
      if (this.currentActiveMovie[id]) {
        let Movielen = Object.entries(this.currentActiveMovie).filter(item => {
          return item[1] === true;
        }).length;
        let crowdLen = Object.entries(this.currentSubCrowd).filter(item => {
          return item[1] === true;
        }).length;
        //被选中
        if (
          this.movieSingleMulti === "single" ||
          (Movielen === 1 && crowdLen !== 0)
        ) {
          //单选
          return {
            background: "#4A4A4A!important",
            "background-size": "100%"
          };
        } else {
          //多选
          //确定电影对应的颜色
          if (index < 0) {
            //为均值
            this.colorMapping.movie[id] = "#D9D9D9";
            return {
              background: "#D9D9D9!important",
              "background-size": "100%"
            };
          }
          this.colorMapping.movie[id] = this.colorArray[index];
          return {
            background: this.colorArray[index] + "!important",
            "background-size": "100%"
          };
        }
      } else {
        //未被选中
        return {
          background: "rgba(0,0,0,0)!important",
          "background-size": "100%"
        };
      }
    },
    refreshActiveMovie(movieList) {
      let tempActiveMovies = {};
      let firstActive = false;
      //为多选的时候
      if (this.movieSingleMulti !== "single") {
        for (let i = 0; i < movieList.length; i++) {
          let item = movieList[i];
          tempActiveMovies[item.id] = true;
        }
        if (this.mainMovie[0]) {
          tempActiveMovies[this.mainMovie[0].id] = true;
        }
        this.currentActiveMovie = Object.assign({}, tempActiveMovies);
        return;
      }
      //为单选的时候
      let arrayToBeActive = [];
      if (this.mainMovie[0] && this.mainMovie[0].id) {
        arrayToBeActive = [{ id: this.mainMovie[0].id }].concat(movieList);
      } else {
        arrayToBeActive = movieList;
      }
      for (let i = 0; i < arrayToBeActive.length; i++) {
        let item = arrayToBeActive[i];
        if (firstActive) {
          break;
        }
        if (item.id !== 0) {
          tempActiveMovies[item.id] = true;
          firstActive = true;
        }
      }
      this.currentActiveMovie = Object.assign({}, tempActiveMovies);
    },
    async getSubCrowdByCrowd(crowdId) {
      let res = await this.surveyApi.getSubCrowdTags({ crowd: crowdId });
      if (res.status === true && res.code === 200 && res.data) {
        this.subCrowd = Object.entries(res.data).map(item => {
          return { id: item[0], name: item[1] };
        });
        let tempCurrentSubCrowd = {};
        if (this.crowdSingleMulti === "single") {
          tempCurrentSubCrowd[this.subCrowd[0].id] = true;
        } else {
          this.subCrowd.forEach(item => {
            tempCurrentSubCrowd[item.id] = true;
          });
        }
        this.currentSubCrowd = Object.assign({}, tempCurrentSubCrowd);
      } else {
        this.subCrowd = [];
      }
    }
  },
  watch: {
    "cycle.id": function(to, from) {
      this.graphType = to === "" ? "line" : "bar";
    },
    "crowd.id": async function(to, from) {
      //call api to get sub crowd
      await this.getSubCrowdByCrowd(to);
    },
    movieList: {
      handler: function(to, from) {
        if (isEqual(to, from)) {
          return;
        }
        if (to[0] && to[0].id === 0) {
          //包含总体均值
          this.includeTotalAverage = true;
        } else {
          this.includeTotalAverage = false;
        }
        //刷新当前组建内的电影状态
        this.refreshActiveMovie(clone(to));
      },
      deep: true
    },
    mainMovie: {
      handler: function(to, from) {
        if (isEqual(to, from)) {
          return;
        }
        if (to[0] && to[0].id) {
          let mainObj = {};
          mainObj[to[0].id] = true;
          this.currentActiveMovie = Object.assign(
            mainObj,
            this.currentActiveMovie
          );
        }
      },
      deep: true
    }
  },
  async created() {
    // //根据store中的movielist 和 active 刷新组建内 movie状态
    let totalActiveMovies = clone(this.movieList);
    // if (this.mainMovie[0] && this.mainMovie[0].id) {
    //   totalActiveMovies.concat(this.mainMovie);
    // }
    // this.totalActiveMovies;
    if (totalActiveMovies.length > 0) {
      this.refreshActiveMovie(clone(totalActiveMovies));
    }
    if (this.crowd) {
      await this.getSubCrowdByCrowd(this.crowd.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.graph-container {
  height: 400px;
  width: 100%;
  background-color: #ffffff;
}
.left-side {
  height: 100%;
  width: 50%;
  padding: 0 40px;
}
.right-side {
  height: 100%;
  width: 50%;
  padding: 0 40px;
}
.page-icon {
  background-size: 100% !important;
  background-position: center;
  background-repeat: no-repeat;
  height: 15px;
  width: 15px;
  &:hover {
    color: #61b6e6;
  }
}
.chart-toggle {
  justify-self: flex-end;
  height: 25px;
  width: 200px;
  border: 1px solid #999999;
  margin-right: 5px;
  .toggle-item {
    width: 50%;
    height: 100%;
    &.is-active {
      background-color: #999999;
      color: white;
    }
  }
}
.title-type {
  height: 40px;
  width: 100%;
  color: #333333;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  .title-type-title {
    max-height: 40px;
    .showDetailIcon {
      margin: 10px;
      background: url(../../assets/images/question@3x.png);
    }
    .cycle-name {
      color: #666666;
    }
  }
  .title-type-type {
    margin: 10px;
    &.type-table {
      background: url(../../assets/images/graph-excel-3x.png);
    }
    &.type-chart {
      background: url(../../assets/images/graph-bar-3x.png);
    }
  }
}
.graph {
  height: 350px;
  width: 100%;
}
.has-no-data {
  height: 200px;
  width: 100%;
  .has-no-data-img {
    margin: 20px 0;
    width: 105px;
    height: 90px;
  }
}
.tag-level2 {
  // height: 40px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  flex-wrap: wrap;
  .subCrowdBox {
    border: 1px solid #eeeeee;
    min-width: 100px;
    // height: 50px;
    padding: 5px 10px;
    margin: 5px 10px;
    white-space: nowrap;
    border-radius: 15px;
  }
}
.movie-list {
  width: 100%;
  flex-wrap: wrap;
  .movie-circle {
    width: 15px;
    height: 15px;
    margin: 0 10px;
    background-color: rgba(0, 0, 0, 0);
    border-radius: 100px;
    border: 1px solid #dadada;
    background-position: center;
    background-size: 100%;
    &.hidden-movie-circle {
      width: 2px;
      visibility: hidden;
    }
  }
  .movieBox {
    min-width: 100px;
    height: 30px;
    margin: 10px 20px 10px 0;
    white-space: nowrap;
    border-radius: 15px;
    background-color: #eaeaea;
    color: #333333;
    &.normal {
    }
    &.not-selected {
      //灰化
    }
  }
}
.hidden-download-btn {
  display: none;
}

.tip-content {
  max-width: 400px;
}
</style>

